/**
 * useParentRequests — « Demandes en cours » de l'accueil parent : ce que la famille a demandé pour l'enfant affiché
 * et attend, une ligne par demande ; le geste en ouvre le détail. Aujourd'hui la demande « Modifier mes créneaux »
 * (`usePendingSlotChange`), dont le détail s'ouvre sur l'abonnement, là où vit son parcours. Une autre demande
 * suivie s'ajoute ici : sa lecture, sa ligne, son détail.
 */
import { useNavigation } from "@react-navigation/native"
import { useCallback, useMemo } from "react"

import { slotChangeRequest } from "../../../formatters/slotChangeFormatter"
import { usePendingSlotChange } from "../../../hooks/usePendingSlotChange"
import { type UIParentRequest } from "../../../types"
import { PARENT_TAB_KEY_TO_ROUTE } from "../parentRoutes"

export function useParentRequests(studentId: string | number | null | undefined): {
    requests: UIParentRequest[]
    openRequest: (request: UIParentRequest) => void
} {
    const { pending } = usePendingSlotChange(studentId)
    const navigation = useNavigation<{ navigate: (name: string, params?: Record<string, unknown>) => void }>()

    const requests = useMemo(() => (pending != null ? [slotChangeRequest(pending)] : []), [pending])

    const openRequest = useCallback(
        (request: UIParentRequest) => {
            if (request.kind === "slot_change") {
                navigation.navigate(PARENT_TAB_KEY_TO_ROUTE.parentSubscription, { triggerSlotChange: true })
            }
        },
        [navigation]
    )

    return { requests, openRequest }
}
